var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmailOutline = function SvgEmailOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125.313H1.875A1.438 1.438 0 00.437 1.75v11.5a1.438 1.438 0 001.438 1.438h17.25a1.438 1.438 0 001.438-1.438V1.75A1.438 1.438 0 0019.125.312zM17.544 1.75L10.5 6.623 3.456 1.75h14.088zM1.875 13.25V2.404L10.09 8.09a.719.719 0 00.82 0l8.215-5.685V13.25H1.875z",
    fill: "#D95437"
  })));
};
export default SvgEmailOutline;